@if (!isWX) {
  <div class="box">
    <img src="/assets/banner.png" alt="" srcset="" />
    <input type="text" [(ngModel)]="userMobile" placeholder="输入手机号码" />
    <div class="btn">
      <input type="text" [(ngModel)]="captcha" placeholder="输入验证码" />
      <button (click)="sendVerificationCode()" [disabled]="count > 0">
        {{ count ? count + 's' : '发送验证码' }}
      </button>
    </div>
    <div class="bt" (click)="submit()">立即下载</div>
  </div>
}
@if (isWX) {
  <div class="guide">
    <img src="/assets/guide.png" alt="" />
  </div>
  <div class="guide-bg">
    <img src="/assets/guide_bg.png" alt="" />
  </div>
  <div class="web">
    暂不支持在微信中使用
    <br />
    <span>请在浏览器中打开</span>
  </div>
}
